"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _cookies = require("@kiwicom/cookies");
var _Modal = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Modal"));
var _CookiesForm2 = _interopRequireDefault(require("./components/CookiesForm"));
var _context = require("../../../../services/log/context");
var _events = require("../../consts/events");
var _jsxRuntime = require("react/jsx-runtime");
var _CookiesForm;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const CookiesCustomize = _ref => {
  let {
    onClose
  } = _ref;
  const {
    log
  } = (0, _context.useLog)();
  const intl = (0, _reactIntl.useIntl)();
  const {
    onAgree,
    onChange
  } = (0, _cookies.useCookies)();
  const handleClose = React.useCallback(() => {
    onAgree(false);
    onChange({
      analytics: false,
      marketing: false
    });
    log(_events.COOKIE_CONSENT_CLOSED, {
      analytics: false,
      marketing: false
    });
    onClose();
  }, [onAgree, onChange, log, onClose]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.default, {
    onClose: handleClose,
    lockScrolling: false,
    fixedFooter: true,
    labelClose: intl.formatMessage({
      id: "orbit.button_close"
    }),
    children: _CookiesForm || (_CookiesForm = /*#__PURE__*/(0, _jsxRuntime.jsx)(_CookiesForm2.default, {}))
  });
};
var _default = exports.default = CookiesCustomize;